<template>
    <div class="componentWrapper">
        <orderInvoice
            @openCartSidebar="$emit('openCartSidebar')"
            @routeChange="routeChange"
            :shippingInstructions="shippingInstructions"
            :packageBoxInstructions="packageBoxInstructions"
            :merchantDeliveryInstructions="merchantDeliveryInstructions"
            :pickupInstructions="pickupInstructions"
            :arrangementMethodInstructions="arrangementMethodInstructions"
            :userSingleOrder="userSingleOrder"
            :shopData="shopData"
            :totalAmount="totalAmount"
            :currentRouteName="currentRouteName"
        />

        <h2 style="margin-top: 35px; margin-bottom: 15px">{{$t('checkoutPage.chooseBank')}}</h2>

        <div class="bankTransfer">
            <div class="bankMethods">
                <div 
                    class="banks" 
                    v-for="(element, index) in paymentMethods" 
                    :key="index"
                >
                    <div class="singleBank" v-if="isActive != index" @click='selectItem(index)' >
                        <img 
                            height="42px"
                            :src="element.logo_url"
                        >
                    </div>
                    <div class="singleBankActive" v-if="isActive == index" @click='selectItem(index)' >
                        <img 
                            height="42px"
                            :src="element.logo_url"
                        >
                    </div>
                </div>
            </div>
            <div class="btns">
                <Button
                    :label="$t('checkoutPage.buttons.payment')"
                    style="width: 100%; height: 50px; margin-top: 50px; font-size: 26px; border-radius: 10px;"
                    @click="payDirectly"
                />
            </div>
        </div>
    </div>
</template>

<script>
import orderInvoice from '@kristjan87/storium-shop-library/src/components/main/checkout/invoice/invoice.vue';

import shippingInstructions from '../apiFetches(old)/shippingInstructions'
import singleOrder from '../apiFetches(old)/singleOrder'
import paymentMethods from '../apiFetches(old)/paymentMethods'

import Button from 'primevue/button';

export default {
    name: 'paymentPage',
    components: {
        Button,
        orderInvoice,
    },
    watch: {
        shippingProfileData: {
            handler(newVal) {
                if (newVal) {
                    this.setShippingProfileMethods();
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        }
    },
    props: {
        idShop: {},
        shopData: {},
        shippingProfileData: {},
        userGroups: null,
        currentRouteName: null
    },
    data() {
        return {
            catchError: null,
            transferError: null,
            isLoading: false,

            idOrder: Number(this.$route.params.idOrder),
            idDeal: Number(this.$route.params.idDeal),
            idListing: null,
            userSingleOrder: '',

            idShippingInstructions: '',

            totalAmount: '',
            amount: null,
            shippingMethods: [],

            shippingInstructions: '',
            packageBoxInstructions: false,
            pickupInstructions: false,
            sellerDeliveryInstructions: false,
            arrangementMethodInstructions: false,
            courierDeliveryInstructions: false,

            isActive: null,
            paymentMethods: [],
            bankInfo: [],
            bankBIC: null,
        };
    },
    methods: {
        routeChange(pageName, idEntity) {
            if(pageName == 'checkoutPage') {
                this.$router.push({ name: pageName, params: { idOrder: idEntity } })
            }
            if(pageName == 'catalogPage') {
                this.$router.push({ name: pageName, params: { id: idEntity } })
            }
        },

        appUp(a, b) {
            return (a + b).toFixed(2);
        },

        round(num, decimalPlaces = 0) {
            num = Math.round(num + "e" + decimalPlaces);
            return Number(num + "e" + -decimalPlaces);
        },

        selectItem(index) {
            if(this.isActive === index) {
                this.isActive = null
            } else {
                this.isActive = index
                this.bankInfo = []
                this.bankInfo.push(this.paymentMethods[index].name)
                this.bankBIC = this.paymentMethods[index].bic
            }
        },

        setShippingProfileMethods() {
            this.shippingMethods = this.shippingProfileData.shippingMethods
            this.shippingProfile = this.shippingProfileData
        },

        orderDataFetch() {
            singleOrder(this.idOrder)
            .then((res) => {
                if(res.data.order.orderStatus.isFormalized) {
                    this.$router.push(this.$frontIp+'/tellimus/'+res.data.order.idOrder+'/'+res.data.order.idDeal)
                }
                this.userSingleOrder = res.data.order.listings
                this.idShippingInstructions = res.data.order.idShippingInstructions
                this.amount = res.data.order.totalAmount
                this.fetchInstructions()
            })
            .catch((error) => {
                console.log(error)
            })
        },

        fetchInstructions() {
            shippingInstructions(this.idShippingInstructions)
            .then((res) => {
                this.shippingInstructions = res.data.shippingInstructions
                this.shippingCost = res.data.shippingInstructions.shippingCost
                this.totalAmount = this.appUp(this.amount, this.shippingCost)
                const idMethod = res.data.shippingInstructions.idShippingMethod
                for(const element of this.shippingMethods) {
                    if(element.idShippingMethod === idMethod) {
                        const shippingOption = element.shippingOption
                        if(shippingOption === 'merchantDelivery') {
                            this.sellerDeliveryInstructions = true
                        }
                        if(shippingOption === 'pickupMethod') {
                            this.pickupInstructions = true
                        }
                        if(shippingOption === 'parcelTerminal') {
                            this.packageBoxInstructions = true
                        }
                        if(shippingOption === 'courierDelivery') {
                            this.courierDeliveryInstructions = true
                        }
                        if(shippingOption === 'arrangement') {
                            this.arrangementMethodInstructions = true
                        }
                    }
                }
            })
        },

        getPaymentMethods () {
            paymentMethods()
            .then((res) => {
                for(const element of res.data.EE) {
                    this.paymentMethods.push(element)
                }
            })
            .catch((err) => {
                this.catchError = err
            })
        },

        payDirectly() {
            fetch(this.$fetchIp+'/v2/transaction/pay-directly', {
            method: 'POST',
            headers: {
                'Content-type':'application/json'
            },
            body: JSON.stringify({
                "bank": this.bankBIC, 
                "idDeal": this.idDeal
                }),
            credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                console.log(res, 'response of payDirectly')
                if(res.message === "Chosen bank for the payment must be one of the valid banks.") {
                    this.transferError = "Ülekande sooritamiseks peate valima panga."
                }
                if(res.status === 'success') {
                    const decodedUrl = decodeURIComponent(res.data.banklink);
                    window.open(decodedUrl, '_self');
                }
            })
        },

        isUserFromGroup(group) {
        if(this.userGroups.some(grupp => grupp === group)) {
            return true
        } else {
            return false
        }
    },

    },
    created() {
        this.getPaymentMethods()
        this.orderDataFetch()
    },
};
</script>

<style scoped>
.bankTransfer {
    padding-bottom: 30px;
    margin-bottom: 50px;
    width: 100%;
    margin-top: 0px;
}
.bankTransfer h3 {
    color: rgb(119, 116, 116);
    margin-top: 10px;
    margin-bottom: -70px;
}
.bankMethods {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    width: 100%;
    -webkit-column-gap: 20px;
       -moz-column-gap: 20px;
            column-gap: 20px;
    row-gap: 25px;
}
.banks {
    text-align: center;
    cursor: pointer;
}
.singleBank {
    width: 260px;
    padding-top: 40px;
    padding-bottom: 36px;
    border-radius: 30px; 
    background: rgb(255, 255, 255);
    -webkit-transition: .1s;
    -o-transition: .1s;
    transition: .1s;
    border: 1px solid rgb(230,230,230);
    background: rgb(245,245,245);
}
.singleBank:hover {
    -webkit-box-shadow: 0px 0px 30px -1px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 0px 30px -1px rgba(0, 0, 0, 0.1);
    background: white;
    border: 1px solid rgba(230, 230, 230, 1);
    margin-top: -3px;
    -webkit-transition: .1s;
    -o-transition: .1s;
    transition: .1s
}
.singleBankActive {
    -webkit-box-shadow: 0px 0px 15px -1px rgba(24, 194, 135, 0.8);
            box-shadow: 0px 0px 15px -1px rgba(24, 194, 135, 0.8);
    width: 260px;
    border: 1px solid rgba(230, 230, 230, 1);
    padding-top: 40px;
    padding-bottom: 36px;
    border-radius: 30px; 
    background: white;
}
.singleBankActive:hover {
    background: white;
    margin-top: -3px;
    -webkit-transition: .1s;
    -o-transition: .1s;
    transition: .1s
}
</style>
